import React from "react";

export function Alert({ kind = "info", children }) {
  const map = {
    success: "bg-green-50 border-green-200 text-green-800",
    error: "bg-red-50 border-red-200 text-red-800",
    info: "bg-blue-50 border-blue-200 text-blue-800",
  };
  return (
    <div className={`mb-4 rounded-lg border px-4 py-2 text-sm ${map[kind] || map.info}`}>
      {children}
    </div>
  );
}
